import { MainContainer } from '../InfoStyled';
import {
	BONUS_DESC_1,
	BONUS_DESC_2,
	PROGRESSIVE_DESC_1,
	PROGRESSIVE_DESC_2
} from '../helpers/content';
import AdditionalSymbol from './AdditionalSymbols';
import SymbolPayouts from './SymbolPayouts';
import Paylines from './Paylines';
import BonusGame from './BonusGame';
import ProgressiveBonusGame from './ProgressiveBonusGame';
// import Quest from "./Quests";
import Specs from './Specs';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import Shortcuts from './Shortcuts';
import GameInterface from './GameInterface';
import Features from './Features';
import { textManager } from '../../lib/lang/TextManager';
import { useTranslation } from '../../locale/context';

export default function Main({ coefs, currentBet, currency, currAbr, fast }) {
	const { t } = useTranslation();
	return (
		<MainContainer>
			<SymbolPayouts
				coefs={coefs}
				currentBet={currentBet}
				slice={{ a: 2, b: coefs.coeffs.length }}
				currency={currency}
				text={textManager.langPack.symbols}
			/>
			<AdditionalSymbol
				coefs={coefs}
				currentBet={currentBet}
				slice={{ a: 0, b: 1 }}
				currency={currency}
				name='additional'
				text={textManager.langPack.additional_symbols}
			/>
			<Paylines text={textManager.langPack.paylines} />
			<Features
				text={textManager.langPack.features}
				currency={currency}
				currentBet={currentBet}
				config={GameConfigs.config}
				currAbr={currAbr}
			/>
			<BonusGame
				text={[BONUS_DESC_1(coefs.minfs), BONUS_DESC_2()]}
				title={t('common.bonus_game')}
			/>
			<ProgressiveBonusGame
				text={[PROGRESSIVE_DESC_1(coefs.minfs), PROGRESSIVE_DESC_2()]}
				title={t('common.progressive_bonus_gameplay')}
			/>
			{/* <Quest /> */}
			<GameInterface currency={currAbr} currentBet={currentBet} />
			<Shortcuts />
			<Specs
				config={GameConfigs.config}
				coefs={coefs.bet_steps}
				currency={currency}
				current={GameConfigs}
			/>
		</MainContainer>
	);
}
